export default __webpack_public_path__ + "static/media/office5full.b1a1ef4b.jpg";